import React, { useEffect, useState } from "react";

import { TabMenu } from "primereact/tabmenu";
import { Outlet, useNavigate } from "react-router-dom";

const Layout = () => {
  const [activeIndex, setActiveIndex] = useState(2);

  useEffect(() => {
    const { hash } = window.location;
    if (hash === "#/devices") return setActiveIndex(1);
    if (hash === "#/" || hash === "") return setActiveIndex(0);
    return setActiveIndex(2);
  }, [window.location.hash]);
  
  const navigate = useNavigate();
  const items = [
    {
      label: "Objects",
      icon: "pi pi-list",
      command: () => {
        navigate("/");
      },
    },
    {
      label: "Devices",
      icon: "pi pi-list",
      command: () => {
        navigate("/devices");
      },
    },
  ];

  return (
    <div>
      <TabMenu model={items} activeIndex={activeIndex} onTabChange={e => setActiveIndex(e.index)} />
      <Outlet />
    </div>
  );
};

export default Layout;
